import { defineStore } from 'pinia'
import { getMe } from '@/api/auth'
import type { LoginResponse } from '@/api/auth'

interface UserState {
  employee: LoginResponse['employee'] | null
  loading: boolean
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    employee: null,
    loading: false
  }),

  getters: {
    isLoggedIn: (state) => !!state.employee,
    userName: (state) => state.employee?.name || '',
    userGonghao: (state) => state.employee?.gonghao || '',
    userAvatar: (state) => state.employee?.avatar || '',
    userDepartment: (state) => state.employee?.departmentName || '',
    userPosition: (state) => state.employee?.position || '',
    isSuperAdmin: (state) => state.employee?.isSuperAdmin || false,
    emailEnabled: (state) => (state.employee as any)?.email_enabled || false,
    userMenus: (state) => (state.employee as any)?.menus || []
  },

  actions: {
    /**
     * 获取当前登录用户信息
     */
    async fetchUserInfo() {
      const token = localStorage.getItem('token')
      if (!token) {
        this.employee = null
        return
      }

      this.loading = true
      try {
        const employee = await getMe()
        this.employee = employee
      } catch (error) {
        console.error('获取用户信息失败:', error)
        // 如果获取失败，清除 token
        localStorage.removeItem('token')
        this.employee = null
      } finally {
        this.loading = false
      }
    },

    /**
     * 设置用户信息（登录时使用）
     */
    setUser(employee: LoginResponse['employee']) {
      this.employee = employee
    },

    /**
     * 清除用户信息（退出登录时使用）
     */
    clearUser() {
      // 先清除 token，再清除 employee，确保状态同步
      localStorage.removeItem('token')
      this.employee = null
    }
  }
})

